import AppRecord from './AppRecord.js'
import APP from 'src/main.js'

class EntityInvoiceFee extends AppRecord {

}

export default EntityInvoiceFee
